"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
require("./three-sixty-rater-single-display-logic.less");
var RaterSingleDisplayLogicController = /** @class */ (function () {
    function RaterSingleDisplayLogicController(
    // @ts-ignore
    $scope, 
    // @ts-ignore
    $filter, 
    // @ts-ignore
    displayLogicService, 
    // @ts-ignore
    displayLogicConstants) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.displayLogicService = displayLogicService;
        this.displayLogicConstants = displayLogicConstants;
        $scope.$ctrl = this;
        this.translate = this.$filter('translate');
    }
    RaterSingleDisplayLogicController.prototype.$onInit = function () {
        // @ts-ignore
        this.displayLogicObj = this.singleDisplayLogic && this.singleDisplayLogic.displayLogic;
        this.raterOptions = this.displayLogicService.getRaterOptions();
        this.operatorOptions = this.displayLogicConstants.getRaterOperatorOptions();
    };
    RaterSingleDisplayLogicController.prototype.getRaterLabel = function () {
        var rater = this.displayLogicObj && this.displayLogicObj.rater;
        return rater ? this.raterOptions[rater] : this.translate('PR.SELECT_RATER_CATEGORY');
    };
    RaterSingleDisplayLogicController.prototype.getOperatorLabel = function () {
        var operator = this.displayLogicObj && this.displayLogicObj.operator;
        return operator ? this.operatorOptions[operator] : this.translate('SELECT_OPERATOR');
    };
    RaterSingleDisplayLogicController.$inject = [
        '$scope',
        '$filter',
        'pr360RaterDisplayLogicService',
        'prDisplayLogicConstants'
    ];
    return RaterSingleDisplayLogicController;
}());
(function (angularModule) {
    angularModule.controller('prRaterSingleDisplayLogicController', RaterSingleDisplayLogicController);
})(angular_1.default.module('qualtrics.pr'));
